export enum ChatEvent {
  ChatSetSettingsAnyToClient = "ChatSetSettingsAnyToClient",
  ChatGetMessages = "ChatGetMessages",
  ChatGetCommands = "ChatGetCommands",
}
